import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './components/GlobalStyles';
import Home from './components/Home';
import About from './components/About';
import Shop from './components/Shop';
import Hypnotherapy from './components/Hypnotherapy';
import Group from './components/Group';
import Workplace from './components/Workplace';
import Terms from './components/Terms';
import AudioList from './components/Ritual';
import Membership from './components/Membership';
import CreativeSignalRitual from './components/CreativeSignalRitual';
import StrategyOfFutureness from './components/StrategyOfFutureness';
import TheContainer from './components/TheContainer';
import Trance from './components/Trance';
 
// App component with Router
const App = () => {
  return (
    <Router>
      <GlobalStyles />
      <div className="app">
        <main>
          <Routes>
            <Route path="/ritual" element= {<AudioList/>}/>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/self-hypnosis" element={<Shop />} />
            <Route path="/hypnotherapy" element={<Hypnotherapy />} />
            <Route path="/group-hypnosis" element={<Group />} />
            <Route path="/workplace" element={<Workplace />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/membership" element={<Membership/>} />
            <Route path="/creative-signal-ritual" element={<CreativeSignalRitual/>} />
            <Route path="/strategy-of-futureness" element={<StrategyOfFutureness/>} />
            <Route path="/the-container" element={<TheContainer/>} />
            <Route path="/trance" element={<Trance/>} />
 
          </Routes>
        </main>
      </div>
    </Router>
  );
};
 
export default App;